import { render } from "./BaseType.vue?vue&type=template&id=0a4db9c6"
import script from "./BaseType.vue?vue&type=script&lang=js"
export * from "./BaseType.vue?vue&type=script&lang=js"

import "./BaseType.vue?vue&type=style&index=0&id=0a4db9c6&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__